import { useId } from '@floating-ui/react';

// receives an id an returns all needed for a11y
function useInputId(component, idProp) {
  var autoId = useId();
  var id = idProp || "".concat(component, "-").concat(autoId);
  var labelId = "".concat(id, "-label");
  var helperTextId = "".concat(id, "-helper-text");
  var prefixId = "".concat(id, "-prefix");
  var suffixId = "".concat(id, "-suffix");
  return {
    id,
    labelId,
    helperTextId,
    prefixId,
    suffixId
  };
}
export default useInputId;